<template>
    <div>
        <h2>Máquina</h2>
        
        <form @submit.prevent="submit">
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                <input class="form__input" v-model.trim="$v.name.$model"/>
                <label class="form__label" :class="{'up': $v.name.$model }">Nome</label>
                <div class="error" v-if="!$v.name.required">Nome é obrigatório</div>
                <div class="error" v-if="!$v.name.minLength">Nome deve conter pelo menos {{$v.name.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.shortName.$error }">
                <input class="form__input" value="" v-model.trim="$v.shortName.$model"/>
                <label class="form__label" :class="{'up': $v.shortName.$model }">Nome curto</label>
                <div class="error" v-if="!$v.shortName.required">Nome curto é obrigatório</div>
                <div class="error" v-if="!$v.shortName.minLength">Nome curto deve conter pelo menos {{$v.shortName.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.category.$error }">
                <input class="form__input" v-model.trim="$v.category.$model"/>
                <label class="form__label up">Categoria</label>
                <div class="error" v-if="!$v.category.required">Categoria é obrigatório</div>
                <div class="error" v-if="!$v.category.minLength">Categoria deve conter pelo menos {{$v.category.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.uri.$error }">
                <input class="form__input" v-model.trim="$v.uri.$model"/>
                <label class="form__label up">URI</label>
                <div class="error" v-if="!$v.uri.required">URI é obrigatório</div>
                <div class="error" v-if="!$v.uri.minLength">URI deve conter pelo menos {{$v.uri.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.description.$error }">
                <trix-vue v-model="$v.description.$model" :name="'description'"></trix-vue>
                <label class="form__label up">Descricrição</label>
                <div class="error" v-if="!$v.description.required">Descrição é obrigatório</div>
                <div class="error" v-if="!$v.description.minLength">Descrição deve conter pelo menos {{$v.description.$params.minLength.min}} caracteres.</div>
            </div>
            
            <div class="form-group" :class="{ 'form-group--error': $v.shortDescription.$error }">
                <trix-vue v-model="$v.shortDescription.$model" :name="'shortDescription'"></trix-vue>

                <!-- <textarea class="form__input" v-model.trim="$v.shortDescription.$model"></textarea> -->
                <label class="form__label up">Descrição curta</label>
                <div class="error" v-if="!$v.shortDescription.required">Descrição curta é obrigatório</div>
                <div class="error" v-if="!$v.shortDescription.minLength">Descrição curta deve conter pelo menos {{$v.shortDescription.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.required.$error }">
                <trix-vue v-model="$v.required.$model" :name="'required'"></trix-vue>

                <!-- <textarea class="form__input" v-model.trim="$v.shortDescription.$model"></textarea> -->
                <label class="form__label up">Requisitos do equipamento</label>
                <div class="error" v-if="!$v.required.required">Requisitos do equipamento é obrigatório</div>
                <div class="error" v-if="!$v.required.minLength">Requisitos do equipamento é curto. Deve conter pelo menos {{$v.required.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.advice.$error }">
                <trix-vue v-model="$v.advice.$model" :name="'advice'"></trix-vue>

                <!-- <textarea class="form__input" v-model.trim="$v.shortDescription.$model"></textarea> -->
                <label class="form__label up">Recomendações</label>
                <div class="error" v-if="!$v.advice.required">Recomendações do equipamento é obrigatório</div>
                <div class="error" v-if="!$v.advice.minLength">Recomendações do equipamento é curto. Deve conter pelo menos {{$v.advice.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group">
                <label class="form__label up">Imagens</label>
                <table>
                    <thead>
                        <tr>
                            <th></th><th>Destaque</th><th>Imagem</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(image, index) in files.images">
                            <image-file :image="image" :index="index" :key="index" :callback="updateImage"></image-file>
                        </template>
                    </tbody>
                </table>
                <button type="button" class="button white button-small" @click="addImage()"><i class="ico-add_a_photo"></i> Incluir foto</button>
            </div>
            <div class="form-group">
                <textarea class="form__input" v-model.trim="videos"/>
                <label class="form__label" :class="{'up': videos }">Vídeos</label>
                <p>Cada URL(link do vídeo) deve estar numa linha</p>
            </div>
            <div class="form-group">
                <label class="form_label up">Atributos</label>
                <table v-if="!loading.attributes">
                    <thead>
                        <tr>
                            <th></th><th>Rótulo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(label, index) in attributes">
                                <attribute v-bind:key="index" :index="index" :remove="removeAttribute" :label="label" :change="changeAttribute"></attribute>
                        </template>
                          
                    </tbody>
                </table>
                <button type="button" class="button white button-small" @click="addAttribute()">Incluir atributo</button>
            </div>
            <div class="form-group">
                <label class="form_label up">Especificações</label>
                <table v-if="!loading.specification">
                    <thead>
                        <tr>
                            <th></th><th>Rótulo</th><th>Mínimo</th><th>Máximo</th><th>Métrica</th><th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(value, index) in specifications">
                                <specification v-bind:key="index" :index="index" :remove="removeSpecification" :label="value.label" :min="value.min" :max="value.max" :metric="value.metric" :change="changeSpecification"></specification>
                        </template>
                    </tbody>
                </table>
                <button type="button" class="button white button-small" @click="addSpecification()">Incluir atributo</button>
            </div>

            <div class="form-group">
                <label class="form_label up">Especificações</label>
                <ul>
                    <li v-for="(first, a) in industry" :key="a">
                        <div class="flex"><input type="checkbox" v-model="lvl0" :value="first.title">{{ first.title }}</div>
                        <ul v-if="first.children">
                            <li v-for="(sec, b) in first.children" :key="b">
                                <div class="flex"><input type="checkbox" v-model="lvl1" :value="`${first.title} > ${sec.title}`">{{ sec.title }}</div>
                                <ul v-if="sec.children">
                                    <li v-for="(tir, c) in sec.children" :key="c">
                                        <div class="flex"><input type="checkbox" v-model="lvl2" :value="`${first.title} > ${sec.title} > ${tir.title}`">{{ tir.title }}</div>
                                        <ul v-if="tir.children">
                                            <li v-for="(fou, d) in tir.children" :key="d">
                                                <div class="flex"><input type="checkbox" v-model="lvl3" :value="`${first.title} > ${sec.title} > ${tir.title} > ${fou.title}`">{{ fou.title }}</div>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            


            
            <button class="button" type="submit" :disabled="submitStatus === 'PENDING' || $v.$invalid">Salvar</button>
            <button class="button white" type="button" @click="submit()">Descartar alterações</button>
            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
        </form>
    </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import TrixVue from '@dymantic/vue-trix-editor'
import ImageFile from './Image'
import Attribute from './Attribute'
import Specification from './Specification'
export default {
    name: "MachinesForm",
    components: {
        TrixVue,
        ImageFile,
        Attribute,
        Specification
    },
    data(){
        return {
            keys: ['name', 'videos', 'shortName', 'description', 'shortDescription', 'created', 'advice', 'attributes', 'category', 'lastUpdate', 'required', 'status', 'uri', 'specifications', 'files'],
            openFiles: false,
            submitStatus: null,
            name: '',
            shortName: '',
            description: '',
            advice: '',
            shortDescription: '',
            files: {
                images: []
            },
            videos: "",
            industry: [],
            lvl0: [],
            lvl1: [],
            lvl2: [],
            lvl3: [],
            attributes: {},
            category: '',
            created: '',
            lastUpdate: '',
            required: '',
            status: '',
            uri: '',
            specifications: [],

            loading: {
                attributes: false,
                specification: false
            }

        }
    },
  
    validations: {
        name: {
            required,
            minLength: minLength(4)
        },
        advice: {
            required,
            minLength: minLength(4)
        },
        required: {
            required,
            minLength: minLength(4)
        },
        shortName: {
            required,
            minLength: minLength(2)
        },
        description: {
            required,
            minLength: minLength(10)
        },
        category: {
            required,
            minLength: minLength(2)
        },
        uri: {
            required,
            minLength: minLength(2)
        },
        shortDescription: {
            required,
            minLength: minLength(10)
        }
    },
    props: {
        machine: {
            type: Object
        },
        callback: {
            type: Function
        }
    },
    mounted(){
        this.loadSnap()
        this.loadIndustry()
        this.$v.$touch()

    },
    methods: {
        removeSpecification(index){
            this.loading.specification = true
            this.specifications.splice(index, 1)
            setTimeout(() => {
                this.loading.specification = false
            },50)
        },
        changeSpecification(index, data){
            this.loading.specification = true
            this.specifications[index] = data
            setTimeout(() => {
                this.loading.specification = false
            },50)
        },
        removeAttribute(key){
            this.loading.attributes = true
            delete this.attributes[key]
            setTimeout(() => {
                this.loading.attributes = false
            },50)
        },
        changeAttribute(key, nV){
            this.attributes[key] = nV
            setTimeout(() => {
                this.loading.attributes = false
            },50)
        },
        addAttribute(){
            this.loading.attributes = true
                this.attributes.push("")
            setTimeout(() => {
                this.loading.attributes = false
            },50)
        },
        addSpecification(){
            this.specifications.push({
                label: '',
                min: '',
                max: '',
                metric: '',
                type: ''
            })
        },
        updateImage(img, index){
            
            this.files.images[index] = img
        },
        addImage(){
            this.files.images.push({})
        },
        loadIndustry(){
            this.$db.collection("industries").get().then((snap) => {
                let slide = {}
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    slide = data
                });
                this.industry = slide.industry
            })  
        },
        loadSnap(){
            this.keys.forEach((key) => {
                if(this.machine.hasOwnProperty(key)){
                    this[key] = this.machine[key]
                }
            })
            this.lvl0 = this.machine['industry.lvl0'] || []
            this.lvl1 = this.machine['industry.lvl1'] || []
            this.lvl2 = this.machine['industry.lvl2'] || []
            this.lvl3 = this.machine['industry.lvl3'] || []
            this.category = this.category.name
            this.files = this.machine.files || {images: []}
        },
        submit() {
            console.log('submit!')
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
            // do your submit logic here
            this.submitStatus = 'PENDING'
            setTimeout(() => {
              this.submitStatus = 'OK'
              this.save()
            }, 500)
            }
        },
        save(){
            let machine = this.machine
            this.keys.forEach((key) => {
                machine[key] = this[key]
            })
            machine['industry.lvl0'] = this.lvl0
            machine['industry.lvl1'] = this.lvl1
            machine['industry.lvl2'] = this.lvl2
            machine['industry.lvl3'] = this.lvl3

            machine.category = {name: machine.category}



            if(this.machine.docId){
                machine.lastUpdate = this.$moment().format('X')
                this.$db.collection("machines").doc(this.machine.docId).set(machine).then(
                    result => {
                        if(result)
                        this.$root.updated = false
                        this.$root.alerts.push({msg: 'Máquina salva com sucesso', type: 'success'})
                        
                    },
                    err => {
                        this.$root.updated = false
                        this.$root.alerts.push({msg: 'Erro: ' + err, type: 'success'})
    
                        }
                );
                this.callback()
            }
            else{
                machine.created = this.$moment().format('X')
                machine.lastUpdate = this.$moment().format('X')
                this.$db.collection('machines').add(machine).then(() => {
                    this.$root.updated = false
                    this.$root.alerts.push({msg: 'Máquina salva com sucesso', type: 'success'})
                    this.callback()
                }).catch((err) => {
                    alert('Erro ao salvar: ' + err)
                })
            }
        }
    }
}
</script>